export default {
  title_one: 'Poistetaanko {{count}} muokkainta?',
  title_other: 'Poistetaanko {{count}} muokkainta?',
  description: '<strong>{{items}}</strong> poistetaan valikosta',
  buttons: {
    yes: 'Kyllä',
    no: 'Ei',
  },
  toasts: {
    failed_to_delete_modifier_one: 'Muokkaimen poistaminen epäonnistui',
    failed_to_delete_modifier_other: 'Muokkainten poistaminen epäonnistui',
    modifiers_got_deleted_one: 'Muokkain poistettu',
    modifiers_got_deleted_other: 'Muokkaimet poistettu',
  },
};
